/**
 * Lets the Messages page tell the app header who the manager is currently
 * chatting with (a client, a staff member, or the staff Everyone channel), so
 * the name shows at the very top regardless of which tab is open.
 */
import { createContext, useContext, useState, ReactNode } from 'react';

type Header = { title: string; sub: string };
const Ctx = createContext<{ title: string; sub: string; setHeader: (title: string, sub?: string) => void }>({
  title: '', sub: '', setHeader: () => {},
});

export function MessagesHeaderProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<Header>({ title: '', sub: '' });
  const setHeader = (title: string, sub = '') => setState((prev) => (prev.title === title && prev.sub === sub ? prev : { title, sub }));
  return <Ctx.Provider value={{ ...state, setHeader }}>{children}</Ctx.Provider>;
}

export function useMessagesHeader() { return useContext(Ctx); }
